module.exports = __webpack_public_path__ + "static/img/btn_gfcz.87ca371.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/btn_gfcz.png
// module id = eCOO
// module chunks = 7